<!-- =========================================================================================
  File Name: EditDomain.vue
  Description: User Edit Page

========================================================================================== -->

<template>
  <vs-popup :active.sync="editTermPopup" title="Edit Set">
    <div class="popup-input" v-if="termData">
      <p class="mb-1 font-semibold">Name</p>
      <vs-input v-model="termData.name" class="mb-3 w-full" />

      <p class="mb-1 font-semibold">Description</p>
      <vs-textarea v-model="termData.description" height="100px" class="mb-3 w-full" />

      <p class="mb-1 font-semibold">Thumbnail</p>
      <vs-input v-model="termData.thumbnail" class="mb-3 w-full" />

      <p class="mb-1 font-semibold">Status</p>
      <div class="flex items-center mb-3">
        <vs-radio v-model="termData.status" vs-name="courseStatus" vs-value="active" class="mr-4">Active </vs-radio>
        <vs-radio v-model="termData.status" vs-name="courseStatus" vs-value="disabled" class="mr-4">Disabled </vs-radio>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import TermDetailsTab from './TermDetailsTab.vue';

export default {
  components: {
    TermDetailsTab,
  },
  data() {
    return {
      editTermPopup: false,
      termData: null,
    };
  },
  methods: {
    loadTermData() {
      this.$http
        .get(`study/term/${this.$route.params.termId}`)
        .then((response) => {
          if (response.status === 200) {
            this.termData = response.data.data;
          }
        })
        .catch((error) => {
          this.errorOccurred = true;
          this.error_msg = error;
        });
    },
    update_termData(data) {
      const pl = data;

      if (pl.term === undefined || pl.definition === undefined) {
        return this.$vs.notify({
          title: 'Failed to update term',
          text: 'Please provide a Term Name',
          color: 'danger',
          position: 'top-right',
        });
      }

      this.$vs.loading();

      this.$http
        .post(`study/term/${this.$route.params.termId}`, pl)
        .then((response) => {
          if (response.status === 200) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: 'Updated Term Successfully',
              text: 'Term has been updated.',
              color: 'success',
              position: 'top-right',
            });
            return this.loadTermData();
          }
        })
        .catch((exception) => {
          this.$vs.loading.close();

          let error = 'An unknown error occurred while updating this term';
          if (exception.response) {
            error = exception.response.data.error.description;
          }

          return this.$vs.notify({
            title: 'Failed to update term',
            text: error,
            color: 'danger',
            position: 'top-right',
          });
        });
    },
  },
  created() {
    this.loadTermData(this.$route.params.termId);
  },
  watch: {
    editSetPopup(val) {
      if (!val) this.updateSet();
    },
  },
};
</script>
